export default {
  formId: 'createTurnoForm',
  formField: {
    cargo: {
      name: 'cargo',
      label: 'Cargo',
      requiredErrorMsg: 'El cargo es requerido.',
    },
    start_hour: {
      name: 'start_hour',
      label: 'Hora entrada',
      requiredErrorMsg: 'Hora entrada es requerido.',
    },
    end_hour: {
      name: 'end_hour',
      label: 'Hora salida',
      requiredErrorMsg: 'Hora salida es requerido.',
    },
    dia: {
      name: 'dia',
      label: 'Dia',
      requiredErrorMsg: 'Dia es requerido.',
    },
    tarde: {
      name: 'tarde',
      label: 'Tarde',
      requiredErrorMsg: 'Tarde es requerido.',
    },
    noche: {
      name: 'noche',
      label: 'Noche',
      requiredErrorMsg: 'Noche es requerido.',
    },
    tarifa: {
      name: 'tarifa',
      label: 'Tarifa',
      requiredErrorMsg: 'Tarifa es requerido.',
    },
    anio: {
      name: 'anio',
      label: 'Año',
      requiredErrorMsg: 'Año es requerido.',
    },
    lunes: {
      name: 'lunes',
      label: 'Lunes',
      requiredErrorMsg: 'Lunes es requerido.',
    },
    martes: {
      name: 'martes',
      label: 'Martes',
      requiredErrorMsg: 'Martes es requerido.',
    },
    miercoles: {
      name: 'miercoles',
      label: 'Miercoles',
      requiredErrorMsg: 'Miercoles es requerido.',
    },
    jueves: {
      name: 'jueves',
      label: 'Jueves',
      requiredErrorMsg: 'Jueves es requerido.',
    },
    viernes: {
      name: 'viernes',
      label: 'Viernes',
      requiredErrorMsg: 'Viernes es requerido.',
    },
    sabado: {
      name: 'sabado',
      label: 'Sabado',
      requiredErrorMsg: 'Sabado es requerido.',
    },
    domingo: {
      name: 'domingo',
      label: 'Domingo',
      requiredErrorMsg: 'Domingo es requerido.',
    },
    festivo: {
      name: 'festivo',
      label: 'Festivo',
      requiredErrorMsg: 'Festivo es requerido.',
    },
  },
};
